<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{$t('common.date')}}</span>
      <el-date-picker
        v-model="changeValue"
        value-format="yyyy-MM-dd"
        type="daterange"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataTable">
      <div class="table-title"> {{$t('DriverAnalysis.dailyWorkHour')}}</div>
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('common.num')">
            <el-select
              v-model="formInline.numberType"
              style="width: 120px"
              :placeholder="$t('common.choseTip')"
              class="selectStyle"
            >
              <el-option
                v-for="item in optionsInput"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              size="mini"
              v-model="formInline.number"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('VEHICLEANALYSIS_VEHICLEORGREPORT_CHANGE_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>